<section>
  <p class="page-section">Template Content Data Export</p>
  <div class="margin-lg">
    <app-template-bulk-edit-export
      [(localeSel)]="this.localeSel"
      [(productSel)]="this.productSel"
      [locales]="this.locales"
      [products]="this.products"></app-template-bulk-edit-export>
  </div>
  <p class="page-section padding-top-lg">Template Content Data Import</p>
  <div class="margin-lg">
    <app-template-bulk-edit-import
      [localeSel]="this.localeSel"
      [productSel]="this.productSel"
      [locales]="this.locales"
      [products]="this.products"></app-template-bulk-edit-import>
  </div>
  <p class="margin-md"></p>
</section>
